var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.725 8.85c.41.41.41 1.075 0 1.485l-5.032 5.032a1.05 1.05 0 0 1-1.485 0L7.8 12.96a1.05 1.05 0 0 1 1.485-1.485l1.665 1.665 4.29-4.29a1.05 1.05 0 0 1 1.485 0",
  clipRule: "evenodd"
})));
export default SvgCheckMark;